<script lang="ts">
  import comingSoon from '$lib/assets/img/blog/coming-soon.png';

  export let post: any;
</script>

{#if post.yoast_head_json.og_image !== undefined}
  <div class="d-flex justify-content-center card-image">
    <img src={`${post.yoast_head_json.og_image[0].url}`} alt={`${post.title.rendered}`} />
  </div>
{/if}

{#if post.yoast_head_json.og_image == undefined}
  <div class="d-flex justify-content-center card-image">
    <img src={comingSoon} alt={'Coming Soon'} />
  </div>
{/if}

<style>
  .card-image {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  img {
    height: 180px;
    object-fit: fill;
  }
</style>
